import React from 'react'
import Modal from 'react-bootstrap/Modal';
import ReactApexChart from "react-apexcharts";
import Tooltip from "@mui/material/Tooltip";
import useWindowDimensions, {humanReadable, humanReadableMinutes} from '../../../../../../utils/useWindowDimensions';
import { CloseIcon, EnlargeIcon } from '../../../../../../assets/icons/iconshere';

const LargeRDSChart = ({userCharts,rdsEnlarge,setRDSEnlarge  }) => {

    let { width , height } = useWindowDimensions();

    const chartData = {
        series: [
            {
                name: "",
                data : userCharts.map((e) => ([e.averageTime.unguided.average.inSeconds , e.averageErrors.unguided]))
            }
        ],
        options: {
            chart: {
                type: 'scatter',
                zoom: {
                    enabled: true,
                    type: 'xy'
                }
            },
            colors: ['#3e4095'],
            xaxis: {
                tickAmount: 5,
                labels: {
                    formatter: (value) => humanReadableMinutes(value)
                },
                title: {
                    text: 'Time (in Minutes)',
                    style: {
                        fontSize: '13px',
                        fontWeight: "500"
                    }
                  }
            },
            yaxis: {
                tickAmount: 5,
                labels: {
                    formatter: (value) => Math.floor(value)
                },
                title: {
                    text: 'Errors',
                    style: {
                        fontSize: '13px',
                        fontWeight: "500"
                    }
                  }
                },
                tooltip: {
                    x: {
                        formatter: (value, { dataPointIndex }) => {
                            return `Users: ${value}`; 
                        }
                    },
                    y: {
                        formatter: (value, { dataPointIndex }) => {
                            const time = chartData.series[0].data[dataPointIndex].time;
                            return `Errors: ${value}, Time: ${humanReadableMinutes(time)}`;
                        }
                    }
            }
            }
    };

  return (
    <>
      <Modal size='xl' centered show={rdsEnlarge} onHide={()=>setRDSEnlarge(false)}>
        <Modal.Body>
            <div className="cardbox overflow-hidden">
                    <div className='d-flex justify-content-between mt-1'>
                     <h5 className="mb-2 pb-0"> Relational Data Summary</h5>
                   { !rdsEnlarge && <div className="text_enlarge_option mb-2
                     ">
                     <Tooltip title="View more">
                        <span className="enlargebtn" onClick={()=>setRDSEnlarge(true)}>
                            <EnlargeIcon/>
                        </span>
                    </Tooltip>
                    </div>
                    }
                    </div>
                    <div id="chart">
                        <ReactApexChart
                            options={chartData.options}
                            series={chartData.series}
                            type="scatter"
                            height={400}
                        />
                    </div>

            </div>
            <span className='close-icon' onClick={()=>setRDSEnlarge(false)}>
            <CloseIcon/>  
            </span>    
        </Modal.Body>
      </Modal>
    </>
  )
}

export default LargeRDSChart
